export default __webpack_public_path__ + "static/media/promo2.39973169.webp";